// User Mutation Types
export const LOGOUT = 'LOGOUT';
export const AUTHENTICATE = 'AUTHENTICATE';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
export const SHOW_SIGNUP_MODAL = 'SHOW_SIGNUP_MODAL';
export const HIDE_SIGNUP_MODAL = 'HIDE_SIGNUP_MODAL';
export const SHOW_RESET_MODAL = 'SHOW_RESET_MODAL';
export const HIDE_RESET_MODAL = 'HIDE_RESET_MODAL';
export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';

// Basket Mutation Types
export const SET_ORDER = 'SET_ORDER';
export const SET_ORDERS = 'SET_ORDERS';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const CLEAR_BASKET = 'CLEAR_BASKET';
export const SET_BASKET_ITEM = 'SET_BASKET_ITEM';
export const SET_BASKET_COUNT = 'SET_BASKET_COUNT';
export const UPDATE_BASKET_ITEM = 'UPDATE_BASKET_ITEM';
export const DELETE_BASKET_ITEM = 'DELETE_BASKET_ITEM';
export const SET_ORDER_RECIPIENT = 'SET_ORDER_RECIPIENT';
export const SET_BACKEND_ORDER_ID = 'SET_BACKEND_ORDER_ID';
export const CLEAR_BACKEND_ORDER_ID = 'CLEAR_BACKEND_ORDER_ID';
export const CLEAR_ORDER_INFORMATION = 'CLEAR_ORDER_INFORMATION';
export const SET_ORDER_PAYMENT_DETAILS = 'SET_ORDER_PAYMENT_DETAILS';

// Demographics Mutation Types
export const SET_TOWNS = 'SET_TOWNS';
export const SET_CITIES = 'SET_CITIES';
export const SET_REGIONS = 'SET_REGIONS';

// Menu Items Mutation Types
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS';

// Restaurants Mutation Types
export const SET_RESTAURANTS = 'SET_RESTAURANTS';

// Payment Modes Mutation Types
export const SET_PAYMENT_MODES = 'SET_PAYMENT_MODES';

// Settings Mutation Types
export const SET_SETTINGS = 'SET_SETTINGS';

// General Page Mutation Types
export const SET_BODY_CLASS = 'SET_BODY_CLASS';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SHOW_APP_LOADER = 'SHOW_APP_LOADER';
export const HIDE_APP_LOADER = 'HIDE_APP_LOADER';
export const HIDE_MOBILE_NAV = 'HIDE_MOBILE_NAV';
export const SHOW_APP_FULL_LOADER = 'SHOW_APP_FULL_LOADER';
export const HIDE_APP_FULL_LOADER = 'HIDE_APP_FULL_LOADER';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js